import { render } from "./TagsContainer.vue?vue&type=template&id=2f655730&scoped=true"
import script from "./TagsContainer.vue?vue&type=script&lang=js"
export * from "./TagsContainer.vue?vue&type=script&lang=js"

import "./TagsContainer.vue?vue&type=style&index=0&id=2f655730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f655730"],['__file',"src/components/TagsContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f655730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f655730', __exports__)) {
    api.reload('2f655730', __exports__)
  }
  
  module.hot.accept("./TagsContainer.vue?vue&type=template&id=2f655730&scoped=true", () => {
    api.rerender('2f655730', render)
  })

}


export default __exports__